<template>
  <div>
    <!-- 搜索 -->
    <div class="search-inner">
      <!-- <a-progress :percent="progress" :stroke-width="10"></a-progress> -->
      <a-form layout="inline">
        <a-form-item class="name" label="学期">
          <a-select
            class="form-cell"
            type="text"
            placeholder="全部"
            v-model="queryParam.termId"
            style="width:280px"
          >
            <a-select-option
              v-for="item in termList"
              :value="item.id"
              :key="item.id"
              :title="`${item.termName}${item.id ? `（${item.startDate}~${item.endDate}）` : ''}`"
              >
              {{ item.termName }}{{ item.id ? `（${item.startDate}~${item.endDate}）` : '' }}
              </a-select-option
            >
          </a-select>
        </a-form-item>
        <a-form-item class="name" label="班级名称">
          <a-input
            class="form-cell"
            type="text"
            placeholder="请输入"
            v-model="queryParam.className"
          ></a-input>
        </a-form-item>
        <a-form-item class="name" label="课程名称">
          <a-input
            class="form-cell"
            type="text"
            placeholder="请输入"
            v-model="queryParam.courseName"
          ></a-input>
        </a-form-item>
        <a-form-item class="name" label="状态">
          <a-select
            class="form-cell"
            type="text"
            placeholder="全部"
            v-model="queryParam.status"
          >
            <a-select-option
              v-for="item in stateList"
              :value="item.status"
              :key="item.status"
              >{{ item.name }}</a-select-option
            >
          </a-select>
        </a-form-item>
        <a-form-item class="name" label="课程类型">
          <a-select
            class="form-cell"
            type="text"
            placeholder="全部"
            v-model="queryParam.cateFirstId"
          >
            <a-select-option
              v-for="item in courseCateLevel"
              :value="item.id"
              :key="item.id"
              >{{ item.name }}</a-select-option
            >
          </a-select>
        </a-form-item>
        <a-form-item class="name" label="课程分类">
          <a-select
            class="form-cell"
            type="text"
            placeholder="全部"
            v-model="queryParam.classifyId "
          >
            <a-select-option
              v-for="item in classifyList"
              :value="item.value"
              :key="item.value"
              >{{ item.label }}</a-select-option
            >
          </a-select>
        </a-form-item>
        <a-form-item class="name" label="年级">
          <a-select
            class="form-cell"
            type="text"
            placeholder="全部"
            v-model="queryParam.gradeId"
          >
            <a-select-option
              v-for="item in schoolGradeList"
              :value="item.gradeTagId"
              :key="item.gradeTagId"
              >{{ item.gradeName }}</a-select-option
            >
          </a-select>
        </a-form-item>
        <a-form-item class="search-oper">
          <a-button type="primary" @click="searchClass()">查询</a-button>
          <a-button type="primary" @click="() => (queryParam = {})"
            >重置</a-button
          >
        </a-form-item>
      </a-form>
    </div>

    <!-- 操作 -->
    <div v-if="isOper_school" class="list-oper">
      <a-button type="primary" icon="plus" @click="$refs.classForm.init('add')"
        >新建</a-button
      >
      <a-button class="batch" type="primary" icon="plus" @click="goBatch()"
        >批量建班</a-button
      >
      <a-button
        class="batch"
        type="primary"
        :disabled="arrAll ===-1? false : true"
        @click="release()"
        >批量发布</a-button
      >
      <a-button
        class="batch"
        type="primary"
        :disabled="arrAll ===0? false : true"
        @click="batchOpenClass()"
        >批量开班</a-button
      >
      <a-button
        class="batch"
        type="primary"
        :disabled="arrAll ===2 || arrAll === -1? false : true"
        @click="batchDelete(record)"
        >批量删除</a-button
      >
      <a-button
        class="batch"
        type="primary"
        :disabled="arrAll ===0? false : true"
        @click="batchRemove()"
        >批量取消</a-button
      >
      <!-- <a-button
        class="batch"
        type="primary"
        @click="release()"
        >发布</a-button
      > -->
      <a-button
        class="batch"
        type="primary"
        v-if="isEditSubmit"
        @click="batchSubmission()"
        >取消</a-button
      >
      <a
        style="margin-left: 15px; text-decoration: underline"
        @click="exportExcel"
        >导出</a
      >
    </div>
    <!-- 表格数据 -->
     <!-- :rowSelection="isEditSubmit ? rowSelection : null"
      -->
    <a-table rowKey="id"
      :row-selection="rowSelection"
      :columns="columns"
      :dataSource="classList"
      class="c-table"
      :pagination="pagination"
      :loading="loading"
      @change="tableChange"
    >
      <span slot="limit" slot-scope="text, record">
        <template>
          <span>{{ record.lowerLimit }}~{{ record.upperLimit }}</span>
        </template>
      </span>
      <span slot="gradeScope" slot-scope="text, record">
        <template>
          <a
            :title="record.gradeScope | gradeScopeFilter"
            style="color: #000000a6"
            >{{ record.gradeScope | gradeScopeFilter }}</a
          >
        </template>
      </span>
      <span slot="continuedTime" slot-scope="text, record">
        <template>
          <span>{{ record.startClassDate }}~{{ record.endClassDate }}</span>
        </template>
      </span>
      <span slot="teachingPlan" slot-scope="text, record">
        <template>
          <div
            v-for="(item, index) in getTeachingPlan(record.teachingPlan)"
            :key="index"
          >
            <span>{{ item.classWeeks | weekName }}</span
            >&nbsp;&nbsp;
            <span>{{ item.classTime }}</span>
          </div>
        </template>
      </span>
      <span slot="action" slot-scope="text, record">
        <template>
          <!-- 学校或者课程方权限 -->
          <!-- <template
            v-if="
              (isOper_school && record.offeringType == '1') ||
              isOper_institution
            "
          > -->
          <!-- 设置老师 -->
          <template v-if="record.controlArrangeTeacherButton">
            <!-- <a-divider type="vertical" /> -->
            <button class="button" @click="$refs.teacherModal.init(record)">设置老师</button>
          </template>
          <!-- </template> -->

          <!-- 学校独有权限 -->
          <template v-if="isOper_school">
            <!--  -1 待发布  0 预开班  1 已开班  2 取消开班 -->

            <!-- 出勤记录 -->

            <!-- 设置教室 -->
            <template>
              <a-divider type="vertical" />
              <button class="button" @click="$refs.resetClassroom.init(record)">设置教室</button>
            </template>

            <template>
              <a-divider type="vertical" />
              <!-- <a @click="$refs.attendanceDetail.init(record)">详情</a> -->
              <router-link
                :to="`/classDetail?id=${record.id}&courseId=${record.courseId}`"
                >详情</router-link
              >
            </template>

            <!-- 确认开班 -->
            <template v-if="record.status == '0'">
              <a-divider type="vertical" />
              <button class="button" @click="confirmClass(record)">确认开班</button>
            </template>

            <!-- 修改 -->
            <template
              v-if="
                record.status == '-1' ||
                record.status == '0' ||
                record.status == '1'
              "
            >
              <a-divider type="vertical" />
              <button class="button" @click="$refs.classForm.init('update', record)">修改</button>
            </template>

            <!-- 发布 -->
            <template v-if="record.status == '-1'">
              <a-divider type="vertical" />
              <button class="button" @click="pushClass(record)">发布</button>
            </template>

            <!-- 删除 -->
            <template v-if="record.status == '-1' || record.status == '2'">
              <a-divider type="vertical" />
              <button class="button" @click="deleteClass(record)">删除</button>
            </template>

            <!-- 复制 -->
            <template
              v-if="
                record.status == '-1' ||
                record.status == '0' ||
                record.status == '2'
              "
            >
              <a-divider type="vertical" />
              <button class="button" @click="$refs.classForm.init('copy', record)">复制</button>
            </template>

            <!-- 取消开班 -->
            <template v-if="record.status == '0'">
              <a-divider type="vertical" />
              <button class="button" @click="cancelClass(record)">取消开班</button>
            </template>
          </template>

          <!-- 学生详情 所有人都有-->
          <template
            v-if="
              record.status == '0' ||
              record.status == '1' ||
              record.status == '2'
            "
          >
            <a-divider type="vertical" />
            <button class="button" @click="$refs.classDetail.init(record)">学生详情</button>
          </template>
          <!-- 预报名-->
          <template v-if="roleId !='4' && (record.status == '0' || record.status == '1')">
            <a-divider type="vertical" />
            <button :class="['button',record.totalPrice ==0? 'disabled-grey':'']"  :disabled=" record.totalPrice ==0? true:false" @click="$refs.preRegistration.init(record)">
              <span class="tooltip" v-if="record.totalPrice ==0">
                预报名
                  <span class="tooltiptext">当前课程价格为0元，不可预报名</span>
                </span>
              <span v-else>预报名</span>
              </button>
          </template>
        </template>
      </span>
    </a-table>
    <class-form-modal
      v-if="isOper_school"
      ref="classForm"
      @addClass="addClass"
    ></class-form-modal>
    <class-teacher-modal
      v-if="isOper_school || isOper_institution"
      ref="teacherModal"
    ></class-teacher-modal>

    <class-detail-modal ref="classDetail"></class-detail-modal>

    <!-- 设置教室 -->
    <reset-classroom-modal ref="resetClassroom"></reset-classroom-modal>

    <attendance-detail-modal ref="attendanceDetail"></attendance-detail-modal>

    <progress-tip ref="progressTip" @closeMain="closeFlesh"></progress-tip>

    <pre-registration-modal ref="preRegistration"></pre-registration-modal>

  </div>
</template>
<script>
import CTable from '../../components/CTable'

import person from '../../api/person'

import classSet from '../../api/classSet'

import ClassFormModal from './ClassFormModal'

import ClassDetailModal from './ClassDetailModal'

import ClassTeacherModal from './ClassTeacherModal'

import { analysisAddress } from '../../utils/address'

import AttendanceDetailModal from './components/AttendanceDetailModal'

import ResetClassroomModal from './components/ResetClassroomModal.vue'

import PreRegistrationModal from './components/PreRegistration'

import ProgressTip from './components/ProgressTip.vue'

import synopsis from '../../api/synopsis.js'

import user from '../../api/user.js'

import Vue from 'vue'
import { downloadFile } from '../../utils'


const columns = [
  {
    title: '学期',
    dataIndex: 'termName',
  },
  {
    title: 'ID',
    dataIndex: 'id',
    width: 50,
  },
  {
    title: '班级名称',
    dataIndex: 'className',
  },
  {
    title: '课程名称',
    dataIndex: 'courseName',
  },
  {
    title: '课程分类',
    dataIndex: 'classifyText',
  },
  {
    title: '老师名称',
    dataIndex: 'teacherName',
  },
  
  // {
  //   title: '教室名称',
  //   dataIndex: 'placeName',
  // },
  {
    title: '适用年级',
    dataIndex: 'gradeScope',
    scopedSlots: { customRender: 'gradeScope' },
    ellipsis: true,
    width: 110,
  },
  {
    title: '报名人数',
    dataIndex: 'successApplyCount',
    width: 50,
  },
  {
    title: '容纳人数',
    dataIndex: 'limit',
    scopedSlots: { customRender: 'limit' },
  },
  {
    title: '上课计划',
    dataIndex: 'teachingPlan',
    scopedSlots: { customRender: 'teachingPlan' },
    width: 180,
  },
  {
    title: '班级状态',
    dataIndex: 'statusText',
  },
  {
    title: '班级标签',
    dataIndex: 'classFlagId',
  },
  {
    title: '开班/结班日期',
    dataIndex: 'continuedTime',
    scopedSlots: { customRender: 'continuedTime' },
    width: 105,
  },
  {
    title: '操作',
    dataIndex: 'action',
    scopedSlots: { customRender: 'action' },
    width: 230,
  },
]

export default {
  name: 'classList',
  data() {
    return {
      arrAll: 100,
      classList: [], //班级数据
      columns, //列标识数据
      queryParam: {}, //查询参数
      loading: true,
      isOper_school: false,
      isOper_institution: false,
      idArr:[],
      courseCateLevel: [...[{id:'',name:'全部'}],...Vue.ls.get('courseCateLevel')],
      pagination: {
        pageSize: 10,
        total: 0,
        showTotal: (total) => `总共 ${total} 条`, // 显示总数
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '30', '50', '70', '100'],
        current: 1,
        currentPage: 1,
      }, //分页数据对象
      // statusList: [
      //   { value: 0, label: '预开班' },
      //   { value: 1, label: '已开班' },
      //   { value: 2, label: '已取消' },
      //   { value: -1, label: '待发布' },
      // ],
      classifyList:[
        { value: '', label: '全部' },
        { value: 1, label: '个性化' },
        { value: 2, label: '社团课' },
        { value: 3, label: '托管班' }
      ],
      termList: [],
      tagsList:[[{id:'',tagName:'全部'}],...Vue.ls.get('tags')],
      schoolGradeList: [...[{id:'',gradeName:'全部'}],...Vue.ls.get('schoolGrade')],
      schoolId: Vue.ls.get('schoolId'),
      isEditSubmit: false, // 是否处于选择发布选择中
      selectedClass: [], //选择的学生
      selectedRowKeys: [],
      roleId: undefined,
      stateList:[
        {name:'全部',status:''},
        {name:'预开班',status:0},
        {name:'已开班',status:1},
        {name:'待发布',status:-1},
        {name:'已取消',status:2},
    ]
    }
  },
  components: {
    CTable,
    ClassFormModal,
    ClassDetailModal,
    ClassTeacherModal,
    ResetClassroomModal,
    AttendanceDetailModal,
    PreRegistrationModal,
    ProgressTip
  },
  methods: {
    exportExcel() {
      let _this = this;
      this.$confirm({
        title: '注意',
        okText: '确定',
        cancelText: '取消',
        icon:'exclamation-circle',
        content: '注意：仅支持导出1万条数据记录，如需导出更多数据请提出人工导出申请',
        onOk() {
          classSet
        .classExport({ schoolId: Vue.ls.get('schoolId'), ..._this.queryParam })
        .then((res) => {
          // window.open(res.data.targetUrl)
          window.location.href = res.data.targetUrl
        })
        },
      })
    },
    // batchRemove(e){
    //   let _this = this;
    //   this.$confirm({
    //     title: '注意',
    //     okText: '确定',
    //     cancelText: '取消',
    //     icon:'exclamation-circle',
    //     content: '注意：仅支持导出1万条数据记录，如需导出更多数据请提出人工导出申请',
    //     onOk() {
    //       classSet
    //     .classExport({ schoolId: Vue.ls.get('schoolId'), ..._this.queryParam })
    //     .then((res) => {
    //       // window.open(res.data.targetUrl)
    //       window.location.href = res.data.targetUrl
    //     })
    //     },
    //   })
    // },
    // 批量删除
    batchDelete(item){
      let _this = this;
      this.$confirm({
        title: '注意',
        okText: '确定',
        cancelText: '取消',
        icon:'exclamation-circle',
        content: `当前已选中${_this.idArr.length}个班级，确认需要进行删除操作吗？`,
        onOk() {
          classSet
        .batchDeleteClass({classIdList:_this.idArr})
        .then((res) => {
          // window.open(res.data.targetUrl)
          // window.location.href = res.data.targetUrl
          _this.$message.success(res.msg ==='success'? '删除成功' : res.msg)
          console.log(res,'res删除是什么内容')
          let value = 100
          _this.searchClass(value)
          _this.arrAll = [];
        })
        },
      })
    },
        // 批量取消
        batchRemove(item){
      let _this = this;
      this.$confirm({
        title: '注意',
        okText: '确定',
        cancelText: '取消',
        icon:'exclamation-circle',
        content: `当前已选中${_this.idArr.length}个班级，确认需要进行取消操作吗？`,
        onOk() {
          classSet
        .batchCancelClass({classIdList:_this.idArr})
        .then((res) => {
          // window.open(res.data.targetUrl)
          // window.location.href = res.data.targetUrl
          _this.$message.success(res.msg ==='success'? '取消成功' : res.msg)
          console.log(res,'res删除是什么内容')
          let value = 100
          _this.searchClass(value)
          _this.arrAll = [];
        })
        },
      })
    },


    async getTermList() {
      const data = await synopsis.getTermList({ schoolId: this.schoolId })
      if (!data) return
      let termList = [{ crossSchool: 0, id: 0, termName: '全部' }]
      this.termList = [...termList,...data.data]
    },
    getTeachingPlan(value) {
      if (value) {
        return JSON.parse(value)
      } else {
        return value
      }
    },

    // 跳转批量建班
    goBatch() {
      this.$router.push({
        name: 'classList/classBatch',
      })
    },

    //批量发布
    pushClass(item) {
      classSet.prepareClass(item.id).then((res) => {
        this.$message.success('发布成功')
        this.$set(item, 'statusText', res.data.statusText)
        this.$set(item, 'status', res.data.status)
      })
    },

    //确认开班
    confirmClass(item) {
      const content =
        item.flexibleSchedule == 0
          ? '开班后，无法撤销'
          : '此班级为灵活排班班级，开班不会自动生成课节，是否确认开班？'
      classSet.checkApplyCount(item.id).then((res) => {
        let self = this
        let data = {
          okText: '确定',
          cancelText: '取消',
          content: content,
          onOk() {
            self.$message.warn('开班中，请耐心等待！')
            self.confirmClass_submit(item)
          },
        }
        if (item.flexibleSchedule == 0)
          (data.title = res.data
            ? '是否确认开班？'
            : '未达到最低开班人数，是否确认开班?'),
            console.log(data)
        this.$confirm(data)

        //灵活排课班级确认弹框提示
        //  this.$confirm({
        //   title: '此班级为灵活排课班级，开班不会自动生成课节，是否确认开班？',
        //   okText: '确定',
        //   cancelText: '取消',
        //   onOk() {
        //     self.$message.warn('开班中，请耐心等待！')
        //     self.confirmClass_submit(item)
        //   },
        // })
      })
    },

    //确认开班接口请求
    confirmClass_submit(item) {
      classSet.confirmClass(item.id).then((res) => {
        this.$message.success('开班成功')
        this.$set(item, 'statusText', res.data.statusText)
        this.$set(item, 'status', res.data.status)
      })
    },

    //取消开班
    cancelClass(item) {
      console.log()
      let self = this
      this.$confirm({
        title: '确认是否取消开班？',
        okText: '确定',
        cancelText: '取消',
        content: '取消后，无法撤销',
        onOk() {
          classSet.cancelClass(item.id).then((res) => {
            self.$message.success('取消开班成功')
            self.$set(item, 'statusText', res.data.statusText)
            self.$set(item, 'status', res.data.status)
          })
        },
      })
    },

    //table发生该表，分页，排序
    tableChange(pagination, filters, sorter) {
      //如果查询有地址的话，把地址解析之后带入
      let obj = analysisAddress(this.queryParam)
      obj.currentPage = pagination.current
      obj.pageSize = pagination.pageSize
      this.queryParam.currentPage = pagination.current
      this.queryParam.pageSize = pagination.pageSize
      window.location.hash = `#${this.$route.path}?params=${JSON.stringify(
        obj
      )}`
      //存在排序的时候
      if (sorter && sorter.columnKey) {
        obj.sorter = `${sorter.columnKey}-${
          sorter.order == 'ascend' ? 'asc' : 'desc'
        }`
      }
      this.getClassList(obj)
      this.arrAll = []
    },

    pageRefresh() {
      this.tableChange(this.pagination, null, null)
    },

    //新增一个班级
    addClass(value) {
      // this.classList.unshift(value)
      this.getClassList(this.queryParam)
    },
    //删除班级
    deleteClass(value) {
      let self = this
      this.$confirm({
        title: '确定要删除吗?',
        okText: '确定',
        cancelText: '取消',
        content: '删除后，无法撤销',
        onOk() {
          classSet.deleteClass(value.id).then((res) => {
            self.$message.success('删除成功')
            //前端模拟删除
            self.deleteClassData(self.classList, value.id)
          })
        },
      })
    },

    //删除数据
    deleteClassData(data, id) {
      for (let i in data) {
        if (data[i].id == id) {
          data.splice(i, 1)
          break
        }
      }
      this.getClassList(this.queryParam)
    },

    //查询班级
    searchClass(value) {
      console.log(value,value==100,'查询班级')
      if(value == 100){
        this.queryParam.currentPage = this.queryParam.currentPage
      this.queryParam.pageSize = this.queryParam.pageSize
      } else {
        this.queryParam.currentPage = 1
      this.queryParam.pageSize = this.queryParam.pageSize
      }
      if (this.queryParam.className)
        this.queryParam.className = this.queryParam.className.trim()
      if (this.queryParam.courseName)
        this.queryParam.courseName = this.queryParam.courseName.trim()
      window.location.hash = `#${this.$route.path}?params=${JSON.stringify(
        this.queryParam
      )}`
      console.log('this.queryParam', this.queryParam)
      // 判断查询的方式
      this.getClassList(this.queryParam,'query')
    },

    //班级列表
    getClassList(params,mode) {
      console.log('params', params)
      if(params.termId == 0) delete params.termId
      this.loading = true
      classSet.getClassList(params).then((res) => {
        console.log('班级列表：', res)
        // 处理当前页面最后一条删除后，页面为空
        if (params.currentPage > 1 && res.data.list.length == 0){
          this.queryParam.currentPage--
          this.getClassList(this.queryParam)
        }
        this.classList = res.data.list.map((item) => {
          if (item.classFlagId.length != 0) {
            let classFlag = [
              { id: 3301, value: '全日制' },
              { id: 3302, value: '半日制' },
              { id: 3303, value: '寒假班' },
              { id: 3304, value: '暑假班' },
              { id: 3305, value: '周末班' },
            ]
            item.classFlagId = item.classFlagId.map((item) => {
              let b
              classFlag.forEach((Item) => {
                if (Item.id == item) {
                  b = Item.value
                }
              })
              return b
            })
          }
          return { ...item, classFlagId: item.classFlagId.join(',') }
        })
        console.log(this.roleId,'roleId是啥')
        if(mode !== 'query' && (this.roleId == 4 || this.roleId == 6)){
          this.schoolGradeList = []
            this.queryParam.gradeId = undefined
          }
          if(this.roleId == 4 || this.roleId == 6){
            this.schoolGradeList = res.schoolGrades
            console.log(this.roleId,res.schoolGrades,'roleId是啥')
          }
        this.classList = this.classList.map((i) => {
          if (!i.teachingPlan) {
            i.teachingPlan = '[]'
          }
          return i
        })

        this.selectedRowKeys = []
        this.selectedClass = []
        this.isEditSubmit = false
        this.loading = false
        //分页信息
        this.pagination = res.data.pagination
      })
    },

    refreshSchool() {
      //父控件选择学校之后，子空间刷新
      if (this.$refs.classForm) {
        this.$refs.classForm.refreshSchool()
      }
      this.getClassList(this.queryParam)
    },

    //是否有操作权限

    judgeIsOper() {
      this.$store.dispatch('getUserInfo').then((res) => {
        console.log('id权限-------------', res.accRole.id)
        //只有才有权限
        let roleId = res.accRole.id.toString()

        //学校有所有权限
        if (['3'].indexOf(roleId) != -1) {
          this.isOper_school = true
        } else {
          this.isOper_school = false
        }

        //课程方只有设置老师的权限
        if (['4'].indexOf(roleId) != -1) {
          this.isOper_institution = true
        } else {
          this.isOper_institution = false
        }
      })
    },
    // 批量提交
    batchSubmission() {
      let _this = this
      this.$confirm({
        title: '注意',
        okText: '确定',
        cancelText: '取消',
        icon:'exclamation-circle',
        content: '当前已选中5个班级，确认需要进行开班操作吗？',
        onOk() {
          // _this.isEditSubmit = !_this.isEditSubmit
        },
      })
    },
    // 批量发布
    release() {
      console.log('queryParam', this.selectedClass)
      let ids = []
      this.selectedClass.forEach((i) => ids.push(i.id))
      console.log(ids)
      if (ids.length == 0) {
        this.$message.error('请选择要发布的班级')
        return
      }
      let _this = this
      this.$confirm({
        title: '注意',
        okText: '确定',
        cancelText: '取消',
        icon:'exclamation-circle',
        content: `当前已选中${_this.idArr.length}个班级，确认需要进行发布操作吗？`,
        onOk() {
          // _this.isEditSubmit = !_this.isEditSubmit
          classSet.batchPrepareClass({ classIdList: ids }).then((res) => {
        console.log(res)
        _this.$message.success(res.msg ==='success'? '发布成功' : res.msg)
        _this.getClassList(_this.queryParam)
        _this.arrAll = [];
      })
        },
      })
    },
    closeFlesh(value){
      this.searchClass(value)
      this.arrAll = [];
    console.log(value,'打印到了100了吗')
  },
    // 批量开班
    batchOpenClass(){
      console.log('批量开班了吗',this)
      let _this = this;
      this.$confirm({
        title: '注意',
        okText: '确定',
        cancelText: '取消',
        icon:'exclamation-circle',
        content: `当前已选中${_this.idArr.length}个班级，确认需要进行开班操作吗？`,
        onOk() {
          classSet
        .batchOpenClass({classIdList:_this.idArr})
        .then((res) => {
          // window.open(res.data.targetUrl)
          // window.location.href = res.data.targetUrl
          _this.$refs.progressTip.init({uuid:res.data.uid})
          // let value = 100
          // setTimeout(()=>{
          //   _this.searchClass(value)
          //  _this.arrAll = [];
          // },2000)
        })
        },
      })
    },
  },
  created() {
    this.$store.dispatch('getUserInfo').then((res) => {
      this.roleId = res.accRole.id
      console.log(this.roleId,'获取状态是什么')
    })
    if (this.$route.params.schoolId) {
      this.$emit('checkSchoolId', this.$route.params.schoolId)
    }
    if (this.$route.query.params) {
      this.queryParam = JSON.parse(this.$route.query.params)
    } else {
      this.queryParam = {}
    }
    if (this.$store.getters.schoolId) {
      this.getClassList(this.queryParam)
    }
    this.judgeIsOper()
    this.getTermList()
    console.log(this.courseCateLevel,'courseCateLevel')
    console.log('tags',Vue.ls.get('tags'))
  },
  computed: {
    rowSelection() {
    let _this = this
      const { selectedRowKeys } = this
      return {
        selectedRowKeys, // 一定要加上这一行代码，清除才会有作用
        onChange: (selectedRowKeys, selectedRows) => {
          console.log('111111111111',selectedRows)
          this.selectedRowKeys = selectedRowKeys
          this.selectedClass = selectedRows
          let arr = []
          let arr2 = []
          selectedRows.map((item,index)=>{
              arr.push(item.status)
              arr2.push(item.id)
              console.log(item.status,'11111111')
          })
          this.idArr = arr2
          console.log(this.selectedClass,'传了id过来了吗')
      console.log(arr,'arr是什么')
          _this.arrAll = arr.every(function(element) {
              return element === arr[0];
            }) && arr[0];
        //  let arr2 =  arr.every(item => {
        //     if(item === 0){
        //       return 0
        //     } else if(item === 1){
        //       return 1
        //     } else if(item === 2){
        //       return 2
        //     } else if (item === 3){
        //       return 3
        //     } else if(item === -1){
        //       return -1
        //     }
        //   })
          console.log('arr是什么内容',this.arrAll)
        },
        // getCheckboxProps: (record) => ({
        //   props: {
        //     disabled: record.status != -1,
        //   },
        // }),
      }
    },
  },
}
</script>
<style lang="scss" scoped>
@import 'src/config/var';
.search-oper {
  button {
    margin: 0px 5px;
  }
}
.list-oper {
  margin: 20px 0px 30px;

  .batch {
    margin-left: 10px;
  }
}
.price-scope {
  width: 100px;
  text-align: center;
}
.max-price {
  border-left: none;
}
.price-gap {
  width: 30px;
  border-left: 0;
  pointer-events: none;
  background: #fff;
}
.button{
  background: none;
  border: 0;
  color: #1890ff;
}
education-content ::v-deep .ant-divider, .ant-divider-vertical{
margin: 0 6px;
}
.disabled-grey{
  color: grey;
}
.tooltip {
    position: relative;
    display: inline-block;
}

.tooltip .tooltiptext {
    visibility: hidden;
    width: 150px;
    background-color: #FFF;
    color: #000;
    text-align: center;
    border-radius: 6px;
    padding: 5px;
    position: absolute;
    z-index: 1;
    bottom: 100%;
    left: 50%;
    margin-left: -60px;
    
    /* 淡入 - 1秒内从 0% 到 100% 显示: */
    opacity: 0;
    transition: opacity 1s;
    border:1px solid black;
    text-align: left;
}

.tooltip:hover .tooltiptext {
    visibility: visible;
    opacity: 1;
}
</style>
